var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNetworkGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#20BBFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.265 16.528H1.222C.548 16.528 0 15.981 0 15.307V9.85c0-.676.548-1.224 1.222-1.224h2.043c.675 0 1.221.548 1.221 1.224v5.457c0 .674-.546 1.221-1.221 1.221M9.015 16.528H6.973c-.675 0-1.223-.547-1.223-1.221V6.973c0-.675.548-1.222 1.223-1.222h2.042c.675 0 1.223.547 1.223 1.222v8.334c0 .674-.548 1.221-1.223 1.221M14.765 16.528h-2.042c-.675 0-1.223-.547-1.223-1.221V4.098c0-.675.548-1.223 1.223-1.223h2.042c.675 0 1.223.548 1.223 1.223v11.209c0 .674-.548 1.221-1.223 1.221",
    transform: "translate(-360 -1033) translate(360 1033)"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M20.515 16.528h-2.042c-.675 0-1.223-.547-1.223-1.221V1.223C17.25.548 17.798 0 18.473 0h2.042c.675 0 1.223.548 1.223 1.223v14.083c0 .675-.548 1.222-1.223 1.222",
    transform: "translate(-360 -1033) translate(360 1033)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkGood);
export default __webpack_public_path__ + "static/media/icon-network-good.e1acd919c201eea8ce5b06d9b16ce33c.svg";
export { ForwardRef as ReactComponent };